"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveAudienceMembership = resolveAudienceMembership;
exports.engageAudienceMembership = engageAudienceMembership;
exports.retlAudienceMembership = retlAudienceMembership;
exports.legacyJourneysAudienceMembership = legacyJourneysAudienceMembership;
const flags_1 = require("./flags");
function resolveAudienceMembership(rawData, syncMode, features) {
    if (!rawData)
        return undefined;
    const engageMembership = engageAudienceMembership(rawData);
    if (typeof engageMembership === 'boolean') {
        return engageMembership;
    }
    const retlMembership = retlAudienceMembership(rawData, syncMode);
    if (typeof retlMembership === 'boolean') {
        return retlMembership;
    }
    if (features?.[flags_1.FLAGS.ACTIONS_LEGACY_JOURNEYS_AUDIENCE_MEMBERSHIP]) {
        const legacyJourneysMembership = legacyJourneysAudienceMembership(rawData);
        if (typeof legacyJourneysMembership === 'boolean') {
            return legacyJourneysMembership;
        }
    }
    return undefined;
}
function engageAudienceMembership(rawData) {
    if (!rawData)
        return undefined;
    const { context: { personas: { computation_class = '', computation_key = '' } = {} } = {}, properties = {}, traits = {}, type = '' } = rawData;
    if (!['audience', 'journey_step'].includes(computation_class))
        return undefined;
    if (!computation_key)
        return undefined;
    let membershipValue;
    if (type === 'identify' && typeof traits?.[computation_key] === 'boolean') {
        membershipValue = traits[computation_key];
    }
    else if (type === 'track' && typeof properties?.[computation_key] === 'boolean') {
        membershipValue = properties[computation_key];
    }
    return typeof membershipValue === 'boolean' ? membershipValue : undefined;
}
function retlAudienceMembership(rawData, syncMode) {
    if (!rawData || !syncMode)
        return undefined;
    const { event = '', type = '' } = rawData;
    if (type !== 'track')
        return undefined;
    if ((syncMode === 'add' && ['new'].includes(event)) ||
        (syncMode === 'update' && ['updated'].includes(event)) ||
        (syncMode === 'upsert' && ['new', 'updated'].includes(event)) ||
        (syncMode === 'mirror' && ['new', 'updated'].includes(event))) {
        return true;
    }
    else if ((syncMode === 'delete' && ['deleted'].includes(event)) ||
        (syncMode === 'mirror' && ['deleted'].includes(event))) {
        return false;
    }
    return undefined;
}
function legacyJourneysAudienceMembership(rawData) {
    if (!rawData)
        return undefined;
    const { context: { personas: { computation_class = '', computation_key = '' } = {} } = {}, properties = {}, traits = {}, type = '' } = rawData;
    let membershipValue;
    if (type === 'track') {
        membershipValue = properties?.[computation_key];
    }
    else if (type === 'identify') {
        membershipValue = traits?.[computation_key];
    }
    if (computation_class === 'journey_step' && typeof membershipValue !== 'boolean') {
        return true;
    }
    return undefined;
}
//# sourceMappingURL=audience-membership.js.map